/**
 * Global SVG filter defs for the iOS 26 "Liquid Glass" refraction.
 * Mount once at the app root. Referenced by `.glass-panel*` utilities
 * via `backdrop-filter: url(#liquid-glass)`.
 */
export const LiquidGlassFilter = () => (
  <svg
    aria-hidden="true"
    style={{ position: 'fixed', width: 0, height: 0, pointerEvents: 'none' }}
  >
    <defs>
      <filter id="liquid-glass" x="0%" y="0%" width="100%" height="100%">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.008 0.012"
          numOctaves="2"
          seed="7"
          result="noise"
        />
        <feGaussianBlur in="noise" stdDeviation="2" result="blurNoise" />
        <feDisplacementMap
          in="SourceGraphic"
          in2="blurNoise"
          scale="60"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
      <filter id="liquid-glass-soft" x="0%" y="0%" width="100%" height="100%">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.015 0.02"
          numOctaves="1"
          seed="3"
          result="noise"
        />
        <feDisplacementMap
          in="SourceGraphic"
          in2="noise"
          scale="25"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
    </defs>
  </svg>
);

export default LiquidGlassFilter;
